import { CUSTOM_ELEMENTS_SCHEMA, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import '@maersk-global/mds-components-core/mc-loading-indicator';
import '@maersk-global/mds-components-core/mc-button';
import { AuthHelper } from './auth-helper';
import { MasterDataService } from '../services/master-data.service';
import { catchError } from 'rxjs';
import { User } from '../models/user.model';
@Component({
  selector: 'app-auth-callback',
  standalone: true,
  imports: [],
  templateUrl: './auth-callback.component.html',
  styleUrl: './auth-callback.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AuthCallback {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly masterDataService = inject(MasterDataService);
  message: string = '';
  isLoginRedirect = true;
  userHasNoRole = false;

  constructor() {
    this.route.queryParamMap.subscribe((params) => {
      if (params.has('code')) {
        this.handleLoginCallback();
      } else {
        this.isLoginRedirect = false;
        this.router.navigate(['/']);
      }
    });
  }

  private handleLoginCallback(): void {
    this.message = 'Login successful, redirecting to application.';
    setTimeout(() => this.fetchUser(), 2 * 1000);
  }

  private fetchUser(): void {
    this.message = 'Fetching user roles.';
    this.masterDataService
      .getUser()
      .pipe(
        catchError((err) => {
          this.setNoRole();
          throw err;
        }),
      )
      .subscribe((user) => this.onUserFetched(user));
  }

  private onUserFetched(user: User): void {
    if (this.isUserInShopOnlyRoleWithNoShop(user)) {
      this.setNoRole();
      return;
    }
    user.maintenanceShops.sort((a, b) => a.maintenanceShopCode.localeCompare(b.maintenanceShopCode));
    AuthHelper.user = user;
    this.message = 'User roles fetched, redirecting to application.';
    setTimeout(() => this.redirectAfterLogin(user), 1000);
  }

  private redirectAfterLogin(user: User): void {
    const returnUrl = AuthHelper.consumeReturnUrl();
    if (returnUrl) {
      this.router.navigateByUrl(returnUrl);
      return;
    }
    const roles = user.roles.map((r) => r.toLowerCase());
    if (
      roles.includes('equipment operator') ||
      roles.includes('sales equipment operator') ||
      roles.includes('redelivery equipment operator')
    ) {
      this.router.navigate(['/import-demand-configuration']);
    } else {
      this.router.navigate(['/workorders']);
    }
  }

  private setNoRole(): void {
    localStorage.clear();
    this.message =
      'You have dont have any assigned role AEMS. Please email EMRCM@maersk.com to get a role. In the email please include your username and the role you need.';
    this.userHasNoRole = true;
  }

  private isUserInShopOnlyRoleWithNoShop(user: User): boolean {
    return user.roles.length === 1 && user.roles[0].toLocaleLowerCase() === 'shop' && user.maintenanceShops.length === 0;
  }

  onLoginAgainClicked(): void {
    this.router.navigate(['/']);
  }
}
